var exports = {
  "c": "lastEditInfoContainer__6mCcpP",
  "F": "editorLogin__g5cPQJ",
};

module.exports = exports;
